import { render, staticRenderFns } from "./UserEditFields.vue?vue&type=template&id=0cd72950&scoped=true"
import script from "./UserEditFields.vue?vue&type=script&lang=ts"
export * from "./UserEditFields.vue?vue&type=script&lang=ts"
import style0 from "./UserEditFields.vue?vue&type=style&index=0&id=0cd72950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd72950",
  null
  
)

export default component.exports